<template>
    <div>
        <registration-codes-form
            :entity-id="entityId"
        ></registration-codes-form>
    </div>
</template>

<script>
import RegistrationCodesForm from '@/components/pages/registrationCodes/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        RegistrationCodesForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
